import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import i18next from "i18next";
import PopupWrapper from "../Common/PopupWrapper";
import {errorRaised} from "@mnjsplatform/data/lib/actions/errorActions";
import MnComboStandalone from "@mnjsplatform/components/lib/common/Dropdown/MnComboStandalone";
import MessageBox from "@mnjsplatform/components/lib/common/MessageBox";

class RequestDialog extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            currentYear: null,
            inOperation: false,
            showMessage: false,
            messageText: "",
            messageTitle: ""
        };
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            let key = {};
            await this.props.dispatch(this.props.dataItem_SelectYear.execute(key));
            await this.changeYear(0);
        } catch (e) {
            console.error(e);
        }
    }

    onClose = () => {
        if (this.props.onClose)
            this.props.onClose();
    }

    onCreate = async(e) => {
        e.preventDefault();
        try {
            const key = {NumYear: this.state.currentYear};
            this.setState({
                messageText: i18next.t("Request_Dialog_1"),
                messageTitle: i18next.t("Request_Dialog_2"),
                showMessage: true
            });
            try {
                await this.props.dispatch(this.props.dataItem_CreateInfo.execute(key));
            }
            finally{
                this.setState({
                    showMessage: false
                });
            }
            console.log('EDocInfoOutIntId=' + JSON.stringify(this.props.dataItem_CreateInfo.getField(0, 'EDocInfoOutIntId')));
            if (!this.props.dataItem_CreateInfo.isError) {
                this.onClose();
            }
        } catch (error) {
            this.props.dispatch(errorRaised(error))
        }
    }

    renderButtons = () => {
        return (<div className="modal-footer text-right">
            <div className="text-right">
                <button className="btn btn-regular"
                        onClick={this.onCreate}>{i18next.t('Save')}
                </button>
                <button className="btn btn-regular"
                        onClick={this.onClose}>{i18next.t('Cancel')}
                </button>
            </div>
        </div>)
    }
    changeYear = async (selectedIndex) => {
        if (selectedIndex < 0)
            return;
        const row = this.props.dataItem_SelectYear.getRow(selectedIndex);
        this.setState({currentYear: row.NumYear});
    }
    render() {
        return (
            <PopupWrapper popupVisible={true} title={i18next.t("New_Reference")} onClose={this.onClose}
                          renderButtons={this.renderButtons} maxWidthBody='300px'>
                <MessageBox visible={this.state.showMessage}
                            title={this.state.messageTitle}
                            messageText={this.state.messageText}
                            onClose={this.onMessageClose}/>

                <div className="row">
                    <div className="col-md-3"></div>
                    <div className="col-md-6"  style={{cursor: 'pointer'}}>
                    <MnComboStandalone
                            ownItem={this.props.dataItem_SelectYear}
                            style={{cursor: 'pointer'}}
                            valueFieldName="NumYear"
                            withSearch={false} onSelected={this.changeYear}/>
                        <div className="col-md-3"></div>
                </div>
                </div>
            </PopupWrapper>
        )
    }
}

RequestDialog.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem_CreateInfo: PropTypes.object,
    dataItem_SelectYear: PropTypes.object,
    onClose: PropTypes.func
}

RequestDialog.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem_SelectYear: state.referencesState.EDocInfoOut_SelYear2NDFL_PO,
        dataItem_CreateInfo: state.referencesState.EDocInfoOut_New2NDFL_PO
    }
}

export default connect(mapStateToProps)(RequestDialog)